import { RESTRICTED } from '@boViews/CollectionDetail/accessRules';
import { clientCounts, countsLine } from '@boViews/shared/clientCounts';

// Summary of the access of a collection of the list, from its `accessTargets` (the hidden targets of a public
// collection, the authorized targets of a restricted one): the `first` target, shown in a restricted collection
// (null in a public one or without target), and the `badge` counting the other targets, `-n` hidden in a public
// collection, `+n` more authorized in a restricted one, or null.
export const accessSummary = ({ visibility, accessTargets }) => {
    const targets = accessTargets ?? [];
    if (visibility === RESTRICTED) {
        return {
            visibility,
            first: targets[0] ?? null,
            badge: targets.length > 1 ? { sign: '+', count: targets.length - 1 } : null,
        };
    }
    return { visibility, first: null, badge: targets.length > 0 ? { sign: '-', count: targets.length } : null };
};

// Line of an access target in the tooltip of the badge: "name (counts)" for a client, its counts without the
// reference (see countsLine), "url (client name)" for a platform.
export const targetLine = (t, { client, platform }) =>
    platform ? `${platform.url} (${client.name})` : `${client.name} (${countsLine(t, { ...clientCounts(client), reference: null })})`;

// Path of the page of an access target, relative to the base url: that of the client, or of the platform.
export const targetPath = ({ client, platform }) =>
    platform ? `clients/${client.uuid}/platforms/${platform.uuid}` : `clients/${client.uuid}`;
